export default "__VITE_ASSET__CBruxrWH__"